import { createTableReducer } from '../common/table';
import { MODELS_TABLE_CONTROLLER } from './ModelsTableConstants';

export default createTableReducer(MODELS_TABLE_CONTROLLER);



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/ModelsTable/ModelsTableReducer.js